import {
  LayoutDashboard,
  ShieldCheck,
  Briefcase,
  AlertOctagon,
  Settings,
  LogOut,
} from 'lucide-react';
import { useAuth } from '@zaogig/auth';
import { useLocation, useNavigate } from 'react-router-dom';

const navItems = [
  { title: '控制台', icon: LayoutDashboard, path: '/' },
  { title: '企业审核', icon: ShieldCheck, path: '/enterprise-review' },
  { title: '岗位审核', icon: Briefcase, path: '/job-review' },
  { title: '风控事件', icon: AlertOctagon, path: '/risk-events' },
  { title: '数据概览', icon: LayoutDashboard, path: '/dashboard' },
  { title: '系统配置', icon: Settings, path: '/system-config' },
];

export default function AdminSidebar() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <aside className="flex h-screen w-64 flex-col bg-slate-900 text-white">
      {/* Header */}
      <div className="flex h-16 items-center gap-2 border-b border-slate-700 px-5">
        <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-indigo-500 font-bold text-white">
          Z
        </div>
        <span className="text-lg font-bold tracking-tight">早知管理</span>
      </div>

      {/* Nav */}
      <nav className="flex-1 space-y-1 overflow-y-auto p-3">
        {navItems.map((item) => {
          const active = location.pathname === item.path;
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={`flex w-full items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium transition-colors ${
                active
                  ? 'bg-indigo-600 text-white'
                  : 'text-slate-300 hover:bg-slate-800 hover:text-white'
              }`}
            >
              <item.icon className="h-5 w-5 shrink-0" />
              <span>{item.title}</span>
            </button>
          );
        })}
      </nav>

      {/* Footer */}
      <div className="border-t border-slate-700 p-3">
        <div className="mb-2 px-3 text-xs text-slate-400">
          {user?.accountId ? `${user.accountId.slice(0, 8)}...` : '未登录'}
        </div>
        <button
          onClick={handleLogout}
          className="flex w-full items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium text-slate-300 transition-colors hover:bg-red-600/20 hover:text-red-400"
        >
          <LogOut className="h-5 w-5" />
          <span>退出登录</span>
        </button>
      </div>
    </aside>
  );
}
